import { useEffect, useState } from 'react'
import useComputed from '@/hooks/use-computed'
import isObject from '@/utils/is-object.js'
import api from '@/services/api/config.js'
import {
	getProvideSystems,
	getConsumeSystems,
	getAllSystems,
	hasOnBehalfOf,
} from './derive-systems'

const useConfig = () => {

	const [loading, setLoading] = useState(false)
	const [errorMsg, setErrorMsg] = useState()

	const [profile] = useState(JSON.parse(sessionStorage.getItem('profile')))


	const [config, setConfig, [identity, provideItems, consumeItems, isProvider, isConsumer, provideSystems, consumeSystems, systems, provideHasOnBehalfOf, consumeHasOnBehalfOf, isAbleToPassiveProvide, isAbleToPassiveConsume]] = useComputed({ produces: null, consumes: null },
		value => value?.identity,
		value => value?.produces ? value.produces : [],
		value => value?.consumes ? value.consumes : [],
		value => value?.produces?.length > 0,
		value => value?.consumes?.length > 0,
		value => value?.produces ? getProvideSystems(value) : [],
		value => value?.consumes ? getConsumeSystems(value) : [],
		value => value?.identity && value?.produces && value.consumes ? getAllSystems(value) : [],
		value => hasOnBehalfOf(value?.produces, 'to'),
		value => hasOnBehalfOf(value?.consumes, 'from'),
		value => value?.produces?.some(el => el.querySchema && Object.keys(el.querySchema).length !== 0),
		value => value?.consumes?.some(el => el.querySchema && Object.keys(el.querySchema).length !== 0),
	)

	useEffect(() => {
		if (profile?.tncStatus) {
			fetch()
		}
	}, [])

	async function fetch() {

		const awaitRecuFun = async () => {
			return new Promise((resolve) => {
				setTimeout(resolve, 1000);
			});
		};

		const recurFun = async () => {
			if (sessionStorage.getItem('config_call_status') === 'fetching') {
				await awaitRecuFun();
				return recurFun();
			}
			const seshConfig = sessionStorage.getItem('config')
			if (seshConfig) {
				return setConfig(JSON.parse(seshConfig))
			}

			setLoading(true)
			sessionStorage.setItem('config_call_status', 'fetching')
			const [error, data] = await api.index()
			sessionStorage.setItem('config', JSON.stringify(data))
			sessionStorage.removeItem('config_call_status')
			setLoading(false)

			if (error) {
				return setErrorMsg(error)
			}
			if (!isObject(data)) {
				return setErrorMsg(error?.error?.message || 'Config is not an object')
			}
			return setConfig(data)
		}

		return recurFun();
	}

	async function find() {

		setLoading(true)

		const [error, data] = await api.index()

		setLoading(false)

		if (error) {
			return setErrorMsg(error)
		}

		if (!isObject(data)) {
			return setErrorMsg('Config is not an object')
		}

		sessionStorage.setItem('config', JSON.stringify(data))
		return data
	}

	const getUniqueDataElements = () =>{
		const de=  [...consumeItems, ...provideItems]
		return de.reduce((unique, item) => {
			return unique.some(el => el.id === item.id) ? unique : [...unique, item];
		}, []);
	}

	return {
		config,
		consumeItems,
		consumeSystems,
		error: errorMsg,
		fetch,
		identity,
		isConsumer,
		isProvider,
		loading,
		provideItems,
		provideSystems,
		systems,
		provideHasOnBehalfOf,
		consumeHasOnBehalfOf,
		find,
		isAbleToPassiveProvide,
		isAbleToPassiveConsume,
		getUniqueDataElements
	}
}

export default useConfig
